import { ofType } from 'redux-observable-es6-compat';
import { mergeMap, map } from 'rxjs/operators';

import { TResort, ASetResorts } from '../actions';

export const fetchResortsEpic = (action$, _, { restApi }) =>
action$.pipe(
  ofType(TResort.FETCH_RESORTS),
  mergeMap(() => restApi.get('/resort')),
  map(ASetResorts)
);

